// HKDSE Chinese Language Complete Mock Data
// 香港中學文憑考試 中國語文科 完整模擬數據

export const hkdseChineseComplete = [
  // Chinese Language Paper 1 - Reading Comprehension
  {
    id: 16,
    name: 'HKDSE 中國語文 卷一 (閱讀理解)',
    nameEn: 'HKDSE Chinese Language Paper 1 (Reading Comprehension)',
    nameCn: 'HKDSE 中国语文 卷一 (阅读理解)',
    nameJa: 'HKDSE 中国語 第一部 (読解)',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試中文閱讀理解、文言文理解和語文運用能力',
    modes: {
      examMode: { name: '考試模式', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "下列哪個詞語的讀音正確？",
        questionEn: "Which pronunciation is correct?",
        hasAudio: true,
        audioUrl: "/audio/chinese/pronunciation_1.mp3",
        options: ["載(zài)重", "載(zǎi)重", "載(zài)歌載舞", "記載(zài)"],
        correctAnswer: 0,
        explanation: "「載重」應讀作「zài」，表示承受重量。「載歌載舞」中的「載」讀作「zài」。",
        explanationEn: "\"載重\" should be pronounced \"zài\", meaning to bear weight.",
        difficulty: "medium",
        topic: "語音知識"
      },
      {
        id: 2,
        question: "請聽以下詩句朗讀，選出正確的韻腳：",
        questionEn: "Listen to the poem recitation and identify the rhyme:",
        hasAudio: true,
        audioUrl: "/audio/chinese/poem_recitation_1.mp3",
        options: ["平聲韻", "仄聲韻", "入聲韻", "混合韻"],
        correctAnswer: 0,
        explanation: "這首詩使用平聲韻，韻腳字都是平聲調。",
        explanationEn: "This poem uses level tone rhyme.",
        difficulty: "hard",
        topic: "詩歌韻律"
      },
      {
        id: 3,
        question: "「君子之交淡如水」中「淡」字的含義是：",
        questionEn: "What does \"淡\" mean in \"君子之交淡如水\"?",
        hasAudio: true,
        audioUrl: "/audio/chinese/idiom_explanation_1.mp3",
        options: ["清淡無味", "平淡樸素", "清澈透明", "簡單容易"],
        correctAnswer: 1,
        explanation: "「淡」在此處指平淡樸素，不追求功利，強調君子之間的友誼純潔。",
        explanationEn: "\"淡\" here means simple and pure, emphasizing the purity of friendship between gentlemen.",
        difficulty: "medium",
        topic: "成語理解"
      },
      {
        id: 4,
        question: "下列哪個句子使用了擬人修辭手法？",
        questionEn: "Which sentence uses personification?",
        hasAudio: true,
        audioUrl: "/audio/chinese/rhetoric_examples.mp3",
        options: ["春風吹綠了大地", "花兒在風中跳舞", "雨後的空氣很清新", "太陽照耀著大地"],
        correctAnswer: 1,
        explanation: "「花兒在風中跳舞」把花兒當作人來寫，賦予了人的動作，是擬人手法。",
        explanationEn: "\"Flowers dancing in the wind\" attributes human actions to flowers, which is personification.",
        difficulty: "easy",
        topic: "修辭手法"
      },
      {
        id: 5,
        question: "古文「學而時習之，不亦說乎」中「說」字應讀作：",
        questionEn: "How should \"說\" be pronounced in the classical text?",
        hasAudio: true,
        audioUrl: "/audio/chinese/classical_pronunciation.mp3",
        options: ["shuō", "yuè", "tuō", "shuì"],
        correctAnswer: 1,
        explanation: "在古文中，「說」通「悅」，讀作「yuè」，表示高興、愉快。",
        explanationEn: "In classical Chinese, \"說\" is interchangeable with \"悅\" and pronounced \"yuè\", meaning happy.",
        difficulty: "hard",
        topic: "古文字音"
      },
      {
        id: 6,
        question: "聽錄音，選出正確的語調變化：",
        questionEn: "Listen and identify the correct tone pattern:",
        hasAudio: true,
        audioUrl: "/audio/chinese/tone_pattern_1.mp3",
        options: ["上升調", "下降調", "平調", "曲折調"],
        correctAnswer: 3,
        explanation: "這句話表達疑問和驚訝，使用曲折調。",
        explanationEn: "This sentence expresses doubt and surprise, using a complex tone pattern.",
        difficulty: "medium",
        topic: "語調分析"
      },
      {
        id: 7,
        question: "「山重水複疑無路，柳暗花明又一村」運用了什麼寫作手法？",
        questionEn: "What writing technique is used in this couplet?",
        hasAudio: true,
        audioUrl: "/audio/chinese/poetry_analysis_1.mp3",
        options: ["對比", "象徵", "比喻", "襯托"],
        correctAnswer: 1,
        explanation: "這句詩通過景物描寫象徵人生的困境和轉機。",
        explanationEn: "This couplet uses scenery to symbolize life's difficulties and opportunities.",
        difficulty: "hard",
        topic: "詩歌賞析"
      },
      {
        id: 8,
        question: "下列哪個字的部首正確？",
        questionEn: "Which character has the correct radical?",
        hasAudio: true,
        audioUrl: "/audio/chinese/character_structure.mp3",
        options: ["想(心部)", "想(木部)", "想(目部)", "想(相部)"],
        correctAnswer: 0,
        explanation: "「想」字的部首是心部，因為思想與心理活動相關。",
        explanationEn: "The radical of \"想\" is \"心\" (heart), as thinking relates to mental activities.",
        difficulty: "easy",
        topic: "漢字結構"
      },
      {
        id: 9,
        question: "聽文言文朗讀，「之」字在句中的作用是：",
        questionEn: "Listen to the classical text and identify the function of \"之\":",
        hasAudio: true,
        audioUrl: "/audio/chinese/classical_function.mp3",
        options: ["結構助詞", "人稱代詞", "指示代詞", "語氣助詞"],
        correctAnswer: 0,
        explanation: "在這個語境中，「之」作為結構助詞，連接修飾語和中心語。",
        explanationEn: "In this context, \"之\" functions as a structural particle connecting modifiers and main words.",
        difficulty: "hard",
        topic: "古文語法"
      },
      {
        id: 10,
        question: "「春蠶到死絲方盡，蠟炬成灰淚始乾」表達了什麼情感？",
        questionEn: "What emotion does this couplet express?",
        hasAudio: true,
        audioUrl: "/audio/chinese/emotion_analysis.mp3",
        options: ["思鄉之情", "愛情的忠貞", "對自然的讚美", "人生的感慨"],
        correctAnswer: 1,
        explanation: "這句詩通過春蠶和蠟燭的比喻，表達愛情的忠貞不渝。",
        explanationEn: "This couplet uses metaphors of silkworms and candles to express unwavering love.",
        difficulty: "medium",
        topic: "詩歌情感"
      },
      {
        id: 11,
        question: "聽成語故事，「畫蛇添足」的寓意是：",
        questionEn: "Listen to the idiom story. What does \"畫蛇添足\" mean?",
        hasAudio: true,
        audioUrl: "/audio/chinese/idiom_story_1.mp3",
        options: ["做事要仔細", "不要多此一舉", "要有創新精神", "團隊合作重要"],
        correctAnswer: 1,
        explanation: "「畫蛇添足」比喻做了多餘的事，反而弄巧成拙。",
        explanationEn: "\"畫蛇添足\" means doing unnecessary things that make matters worse.",
        difficulty: "easy",
        topic: "成語寓意"
      },
      {
        id: 12,
        question: "下列哪個詞語的感情色彩是褒義的？",
        questionEn: "Which word has a positive connotation?",
        hasAudio: true,
        audioUrl: "/audio/chinese/emotional_color.mp3",
        options: ["狡猾", "精明", "奸詐", "陰險"],
        correctAnswer: 1,
        explanation: "「精明」是褒義詞，表示聰明能幹；其他都是貶義詞。",
        explanationEn: "\"精明\" is a positive word meaning smart and capable; others are negative.",
        difficulty: "easy",
        topic: "詞語色彩"
      },
      {
        id: 13,
        question: "聽古詩朗誦，這首詩的平仄格律是：",
        questionEn: "Listen to the ancient poem. What is its tonal pattern?",
        hasAudio: true,
        audioUrl: "/audio/chinese/poem_meter.mp3",
        options: ["平平仄仄平平仄", "仄仄平平仄仄平", "平仄平仄平平仄", "仄平仄平仄仄平"],
        correctAnswer: 1,
        explanation: "這是七言律詩的標準格律：仄仄平平仄仄平。",
        explanationEn: "This follows the standard meter of seven-character regulated verse.",
        difficulty: "hard",
        topic: "詩歌格律"
      },
      {
        id: 14,
        question: "「欲窮千里目，更上一層樓」運用了什麼表現手法？",
        questionEn: "What literary technique is used in this couplet?",
        hasAudio: true,
        audioUrl: "/audio/chinese/literary_technique.mp3",
        options: ["直抒胸臆", "借景抒情", "托物言志", "情景交融"],
        correctAnswer: 2,
        explanation: "詩人通過登樓這一具體行為來表達遠大的志向，是托物言志。",
        explanationEn: "The poet expresses great aspirations through the concrete action of climbing a tower.",
        difficulty: "medium",
        topic: "表現手法"
      },
      {
        id: 15,
        question: "聽現代文朗讀，文中使用的修辭手法主要是：",
        questionEn: "Listen to the modern text. What is the main rhetorical device?",
        hasAudio: true,
        audioUrl: "/audio/chinese/modern_rhetoric.mp3",
        options: ["比喻", "排比", "對偶", "反問"],
        correctAnswer: 1,
        explanation: "文中多處使用排比句式，增強語言的氣勢和感染力。",
        explanationEn: "The text uses parallelism extensively to enhance momentum and emotional impact.",
        difficulty: "medium",
        topic: "現代文修辭"
      },
      {
        id: 16,
        question: "「紅豆生南國，春來發幾枝」中「紅豆」象徵什麼？",
        questionEn: "What does \"紅豆\" symbolize in this poem?",
        hasAudio: true,
        audioUrl: "/audio/chinese/symbolism.mp3",
        options: ["思鄉之情", "相思之情", "友誼之情", "親情之愛"],
        correctAnswer: 1,
        explanation: "紅豆在中國文化中象徵相思之情，常用來表達男女之間的思念。",
        explanationEn: "Red beans symbolize lovesickness in Chinese culture, often expressing longing between lovers.",
        difficulty: "easy",
        topic: "文化象徵"
      },
      {
        id: 17,
        question: "聽文言文片段，「而」字的語法功能是：",
        questionEn: "Listen to the classical text. What is the grammatical function of \"而\"?",
        hasAudio: true,
        audioUrl: "/audio/chinese/classical_grammar.mp3",
        options: ["表轉折", "表並列", "表承接", "表因果"],
        correctAnswer: 0,
        explanation: "在這個語境中，「而」表示轉折關係，相當於現代漢語的「但是」。",
        explanationEn: "In this context, \"而\" indicates contrast, equivalent to \"but\" in modern Chinese.",
        difficulty: "medium",
        topic: "文言虛詞"
      },
      {
        id: 18,
        question: "下列哪個成語使用正確？",
        questionEn: "Which idiom is used correctly?",
        hasAudio: true,
        audioUrl: "/audio/chinese/idiom_usage.mp3",
        options: [
          "他的演講振聾發聵，讓人深思",
          "這道菜色香味俱全，振聾發聵",
          "春天的花朵振聾發聵地開放",
          "他振聾發聵地走進教室"
        ],
        correctAnswer: 0,
        explanation: "「振聾發聵」比喻言論能使人醒悟，只能用於演講、文章等能啟發人的事物。",
        explanationEn: "\"振聾發聵\" means words that can enlighten people, only used for speeches or writings that inspire.",
        difficulty: "medium",
        topic: "成語運用"
      },
      {
        id: 19,
        question: "聽散文朗讀，作者的寫作意圖主要是：",
        questionEn: "Listen to the prose. What is the author's main intention?",
        hasAudio: true,
        audioUrl: "/audio/chinese/prose_intention.mp3",
        options: ["描寫自然景色", "抒發個人情感", "說明道理", "記敘事件"],
        correctAnswer: 1,
        explanation: "這篇散文通過景物描寫來抒發作者的個人情感和感悟。",
        explanationEn: "This prose expresses the author's personal emotions and insights through scenic descriptions.",
        difficulty: "medium",
        topic: "散文分析"
      },
      {
        id: 20,
        question: "「落紅不是無情物，化作春泥更護花」體現了什麼哲理？",
        questionEn: "What philosophy does this couplet embody?",
        hasAudio: true,
        audioUrl: "/audio/chinese/philosophy.mp3",
        options: ["生命的循環", "奉獻的精神", "自然的規律", "愛的偉大"],
        correctAnswer: 1,
        explanation: "這句詩通過落花化泥護花的比喻，體現了無私奉獻的精神。",
        explanationEn: "This couplet uses the metaphor of fallen flowers becoming soil to embody the spirit of selfless dedication.",
        difficulty: "medium",
        topic: "詩歌哲理"
      },
      {
        id: 21,
        question: "聽古文朗讀，「焉」字在文中的意思是：",
        questionEn: "Listen to the classical text. What does \"焉\" mean here?",
        hasAudio: true,
        audioUrl: "/audio/chinese/classical_word.mp3",
        options: ["哪裡", "怎麼", "什麼", "為什麼"],
        correctAnswer: 0,
        explanation: "在這個語境中，「焉」是疑問代詞，表示「哪裡」的意思。",
        explanationEn: "In this context, \"焉\" is an interrogative pronoun meaning \"where\".",
        difficulty: "hard",
        topic: "古文詞義"
      },
      {
        id: 22,
        question: "下列哪個句子的語序正確？",
        questionEn: "Which sentence has correct word order?",
        hasAudio: true,
        audioUrl: "/audio/chinese/word_order.mp3",
        options: [
          "他把書昨天買的給了我",
          "他把昨天買的書給了我",
          "他昨天把買的書給了我",
          "昨天他把書買的給了我"
        ],
        correctAnswer: 1,
        explanation: "正確的語序是：他把昨天買的書給了我。修飾語應緊貼被修飾語。",
        explanationEn: "The correct order is: 他把昨天買的書給了我. Modifiers should be close to what they modify.",
        difficulty: "easy",
        topic: "語法語序"
      },
      {
        id: 23,
        question: "聽詩歌朗誦，這首詩的情感基調是：",
        questionEn: "Listen to the poem. What is its emotional tone?",
        hasAudio: true,
        audioUrl: "/audio/chinese/emotional_tone.mp3",
        options: ["豪放激昂", "婉約憂傷", "平和淡然", "憤怒激烈"],
        correctAnswer: 1,
        explanation: "這首詩的語調柔和，表達了淡淡的憂傷和思念之情，屬於婉約風格。",
        explanationEn: "This poem has a gentle tone expressing mild sadness and longing, belonging to the graceful style.",
        difficulty: "medium",
        topic: "詩歌風格"
      },
      {
        id: 24,
        question: "「滄海桑田」這個成語的本義是指：",
        questionEn: "What is the original meaning of \"滄海桑田\"?",
        hasAudio: true,
        audioUrl: "/audio/chinese/idiom_origin.mp3",
        options: ["地理變化", "時間變遷", "人事變化", "自然災害"],
        correctAnswer: 0,
        explanation: "「滄海桑田」本義指大海變成桑田，桑田變成大海，比喻地理環境的巨大變化。",
        explanationEn: "\"滄海桑田\" originally means the sea becoming farmland and farmland becoming sea, referring to great geographical changes.",
        difficulty: "medium",
        topic: "成語本義"
      },
      {
        id: 25,
        question: "聽現代詩朗誦，詩中運用的主要意象是：",
        questionEn: "Listen to the modern poem. What is the main imagery?",
        hasAudio: true,
        audioUrl: "/audio/chinese/modern_poetry.mp3",
        options: ["風雨", "花鳥", "山水", "星月"],
        correctAnswer: 3,
        explanation: "這首現代詩主要運用星月意象來表達詩人的情感和思考。",
        explanationEn: "This modern poem mainly uses star and moon imagery to express the poet's emotions and thoughts.",
        difficulty: "medium",
        topic: "現代詩意象"
      },
      {
        id: 26,
        question: "下列哪個字的筆順正確？",
        questionEn: "Which character has the correct stroke order?",
        hasAudio: true,
        audioUrl: "/audio/chinese/stroke_order.mp3",
        options: ["筆(竹-毛-聿)", "筆(竹-聿-毛)", "筆(毛-竹-聿)", "筆(聿-竹-毛)"],
        correctAnswer: 0,
        explanation: "「筆」字的正確筆順是先寫竹字頭，再寫毛，最後寫聿。",
        explanationEn: "The correct stroke order for \"筆\" is bamboo radical first, then \"毛\", finally \"聿\".",
        difficulty: "easy",
        topic: "漢字筆順"
      },
      {
        id: 27,
        question: "聽文學作品片段，這段文字的文體特徵是：",
        questionEn: "Listen to the literary excerpt. What are its stylistic features?",
        hasAudio: true,
        audioUrl: "/audio/chinese/literary_style.mp3",
        options: ["議論文體", "記敘文體", "說明文體", "抒情文體"],
        correctAnswer: 3,
        explanation: "這段文字以抒發情感為主，語言優美，具有明顯的抒情文體特徵。",
        explanationEn: "This text focuses on expressing emotions with beautiful language, showing clear lyrical style features.",
        difficulty: "medium",
        topic: "文體特徵"
      },
      {
        id: 28,
        question: "「山不在高，有仙則名」使用了什麼句式？",
        questionEn: "What sentence pattern is used in \"山不在高，有仙則名\"?",
        hasAudio: true,
        audioUrl: "/audio/chinese/sentence_pattern.mp3",
        options: ["判斷句", "被動句", "倒裝句", "省略句"],
        correctAnswer: 0,
        explanation: "這是判斷句，用「則」字表示判斷，說明山因有仙而出名的道理。",
        explanationEn: "This is a judgment sentence using \"則\" to indicate judgment, explaining that mountains become famous because of immortals.",
        difficulty: "medium",
        topic: "句式分析"
      },
      {
        id: 29,
        question: "聽古典小說片段，這段描寫運用了什麼手法？",
        questionEn: "Listen to the classical novel excerpt. What technique is used?",
        hasAudio: true,
        audioUrl: "/audio/chinese/novel_technique.mp3",
        options: ["正面描寫", "側面描寫", "對比描寫", "細節描寫"],
        correctAnswer: 1,
        explanation: "這段文字通過他人的反應來表現主人公的特點，屬於側面描寫。",
        explanationEn: "This text reveals the protagonist's characteristics through others' reactions, which is indirect description.",
        difficulty: "medium",
        topic: "小說技巧"
      },
      {
        id: 30,
        question: "「知之者不如好之者，好之者不如樂之者」體現了什麼教育思想？",
        questionEn: "What educational philosophy does this quote embody?",
        hasAudio: true,
        audioUrl: "/audio/chinese/education_philosophy.mp3",
        options: ["因材施教", "循序漸進", "興趣為先", "實踐為主"],
        correctAnswer: 2,
        explanation: "這句話強調學習興趣的重要性，體現了以興趣為先的教育思想。",
        explanationEn: "This quote emphasizes the importance of learning interest, embodying an interest-first educational philosophy.",
        difficulty: "medium",
        topic: "教育思想"
      }
    ]
  }
]; 